import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'
import RoleControlled from '../../_common/RoleControlled'

import { toggleVisibility, showToast } from '../../../actions'
import { URL } from '../../../const'
import Loader from '../../_common/Loader'

// import { postForm } from '../../actions'

class Pickup extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      title: '',
      content: '',
      video_url: '',
      hp_url: '',
      image: '',
      image_url: '',
      image_error: '',
      show_panel: false
    }
  }
  componentDidMount () {
    this._fetchData()
  }
  async _fetchData () {
    this.setState({ loading: true })
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`
      }
    }
    const url = `${URL}pickup/${this.props.propertyID}`
    try {
      const res = await axios.get(
        url,
        config
      )
      const { title, content, video_url, hp_url, image } = res.data.item
      this.setState({
        title,
        content,
        video_url,
        hp_url,
        image_url: image,
        loading: false,
        show_panel: res.data.show
      })
    } catch (error) {
      console.log('An error occured while fetching residents data.')
    }
  }
  _handleEnablePanel (e) {
    this.setState({ show_panel: e.target.checked })
    this.props.toggleVisibility(this.props.propertyID, 6, e.target.checked)
  }
  _handleContentChange (key, e) {
    this.setState({ [key]: e.target.value })
  }

  async _handleImageChange (e) {
    const image = e.target.files[0]
    if (image) {
      if (
        (image.type === 'image/png' || image.type === 'image/jpeg' || image.type === 'image/jpeg') &&
        (image.name.indexOf('png') > 0 || image.name.indexOf('jpeg') > 0 || image.name.indexOf('jpg') > 0)
      ) {
        let reader = new FileReader()
        reader.onload = (e) => {
          this.setState({image_url: e.target.result})
        }
        reader.readAsDataURL(e.target.files[0])
        this.setState({ image })
      } else {
        this.setState({ image_error: '画像ファイル外を選択しました。\n確認の上でもう一度画像ファイルを選択してください。' })
      }
    }
  }

  async _handleFormSubmit (e) {
    e.preventDefault()

    const data = _.omit(this.state, ['image', 'image_error', 'image_url'])
    const image = this.state.image
    console.log('data: ', data)

    const url = `${URL}pickup/${this.props.propertyID}`
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        'Authorization': `Token ${this.props.user.token}`
      }
    }

    const formData = new FormData()
    formData.append('data', JSON.stringify(data))
    if (image) {
      const imageExtension = image.name.split('.').pop()
      const imageName = `pickup-property${this.props.propertyID || '000'}-${Date.now()}.${imageExtension}`

      console.log('image: ', image)
      console.log('imageName: ', imageName)
      formData.append('image', image, imageName)
    } else {
      formData.append('image', null)
    }

    try {
      const res = await axios.post(
        url,
        formData,
        config
      )
      console.log('res: ', res)
      this.props.showToast('保存しました！', 'primary')
      this._fetchData()
    } catch (error) {
      console.log('error: ', error)
      this.props.showToast('エラーが発生しました。', 'danger')
    }
  }

  _resetImage () {
    this.setState({ image: '', image_url: '' })
    document.getElementById('image').value = ''
  }

  _renderImageLabel () {
    if (this.state.image_url) {
      return (
        <div className="label_container">
          <label className="image_input_label image_selected" htmlFor="image">
            <img className="img-responsive" src={this.state.image_url} alt=""/>
          </label>
          <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
            <div className="delete_container" onClick={this._resetImage.bind(this)}>
              <span></span>
              <span></span>
            </div>
          </RoleControlled>
        </div>
      )
    }
    return (
      <div className="label_container">
        <label className="image_input_label image_blank" htmlFor="image">
          <svg className="add" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="16"></line>
            <line x1="8" y1="12" x2="16" y2="12"></line>
          </svg>
        </label>
      </div>
    )
  }

  _renderForm () {
    // if (!this.props.push.loading) {
    return (
      <form onSubmit={ this._handleFormSubmit.bind(this) }>
        <div className="input-group flex column">
          <label className="label" htmlFor="title">件名</label>
          <input
            type="text"
            id="title"
            className="medium_input"
            placeholder="件名"
            readOnly={Number(this.props.user.user_role) === 2}
            value={this.state.title}
            onChange={this._handleContentChange.bind(this, 'title')}
          />
        </div>

        <div className="input-group flex column">
          <label className="label" htmlFor="content">本文</label>
          <textarea
            id="content"
            className="large_input"
            value={this.state.content}
            readOnly={Number(this.props.user.user_role) === 2}
            onChange={this._handleContentChange.bind(this, 'content')}
          >
          </textarea>
        </div>

        <div className="input-group flex column">
          <label className="label" htmlFor="image">
            画像
            <span className="smallest">（JPEG・PNGファイルのみ）</span>
          </label>
          <div className="image_input_container flex">
            { this._renderImageLabel() }
            <div>
              <div className="image_error small">{ this.state.image_error }</div>
              <input
                type="file"
                id="image"
                disabled={Number(this.props.user.user_role) === 2}
                onChange={this._handleImageChange.bind(this)}
              />
            </div>
          </div>
        </div>

        <div className="input-group flex column">
          <label className="label" htmlFor="youtube">動画リンク</label>
          <input
            type="url"
            id="youtube"
            className="medium_input"
            placeholder="動画リンク"
            readOnly={Number(this.props.user.user_role) === 2}
            value={this.state.video_url}
            onChange={this._handleContentChange.bind(this, 'video_url')}
          />
        </div>

        <div className="input-group flex column">
          <label className="label" htmlFor="hp_url">外部リンク</label>
          <input
            type="url"
            id="hp_url"
            className="medium_input"
            placeholder="外部リンク"
            readOnly={Number(this.props.user.user_role) === 2}
            value={this.state.hp_url}
            onChange={this._handleContentChange.bind(this, 'hp_url')}
          />
        </div>
        <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
          <div className="button_container flex justify-center">
            <Link to="/owners" className="btn cancel_btn">キャンセル</Link>
            <button className="btn submit_btn" type="submit">保存</button>
          </div>
        </RoleControlled>
      </form>
    )
    // }
    // return <Loader classname="loader_dot_circle"/>
  }
  _renderLoader () {
    if (this.state.loading) {
      return <Loader classname="loader_dot_circle small"/>
    }
    return null
  }

  render () {
    // if (this.props.push && this.props.push.postSuccess) {
    //   return <Redirect to='/push' />
    // }
    return (
      <section className="owner_form add_form">
        <h4 className="page_title bold flex justify-between">
          <div className="title flex">
            <span>ピックアップ</span>
            { this._renderLoader() }
          </div>
          <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
            <div className="switch">
              <input type="checkbox" id="showSwitch" className="switch-input" key="checkbox" onChange={this._handleEnablePanel.bind(this)} checked={this.state.show_panel}/>
              <label htmlFor="showSwitch" className="switch-label" key="label">
                <span className="toggle--on">表示</span>
                <span className="toggle--off">非表示</span>
              </label>
            </div>
          </RoleControlled>
        </h4>
        {
          this.state.show_panel
            ? (
              <div>
                {
                  this.state.loading
                    ? <Loader classname="loader_dot_circle"/>
                    : this._renderForm()
                }
              </div>
            )
            : null
        }
      </section>
    )
  }
}

function mapStateToProps ({ user }) {
  return { user }
}

export default connect(mapStateToProps, { toggleVisibility, showToast })(Pickup)



// WEBPACK FOOTER //
// ./src/components/Properties/Pickup/index.js